export const GET_CUST_INVEST = "GET_CUST_INVEST";
export const GET_CUST_INVEST_SUCCESS = "GET_CUST_INVEST_SUCCESS";
export const GET_CUST_INVEST_FAILED = "GET_CUST_INVEST_FAILED";
